import { render, staticRenderFns } from "./SpeakerResultCard.vue?vue&type=template&id=918a2e9a&scoped=true"
import script from "./SpeakerResultCard.vue?vue&type=script&lang=js"
export * from "./SpeakerResultCard.vue?vue&type=script&lang=js"
import style0 from "./SpeakerResultCard.vue?vue&type=style&index=0&id=918a2e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a2e9a",
  null
  
)

export default component.exports